<!-- NOTIFICACIÓN ESTÁNDAR -->
<p-toast key="default" position="top-right" [baseZIndex]="9999" />

<!-- NOTIFICACIÓN PUSH (con clase exclusiva) -->
<p-toast
  key="push"
  position="bottom-right"
  styleClass="toast-push !p-0 !border-none !shadow-none"
  [baseZIndex]="9999">
  <ng-template let-message pTemplate="message">
    <div
      class="flex items-start gap-3 max-w-sm w-full p-4 bg-surface-0 dark:bg-surface-800 rounded-xl shadow-md transition-all duration-300">
      <!-- Avatar -->
      <img
        *ngIf="message?.data?.avatar"
        [src]="message.data.avatar"
        alt="avatar"
        class="w-10 h-10 rounded-full" />

      <!-- Contenido -->
      <div class="flex flex-col w-full overflow-hidden">
        <p
          class="text-sm font-semibold text-surface-900 dark:text-surface-100 truncate">
          {{ message.summary }}
        </p>
        <p class="text-sm text-surface-700 dark:text-surface-300 truncate">
          {{ message.detail }}
        </p>

        <!-- Acción -->
        <button
          *ngIf="message?.data?.action"
          class="mt-2 text-xs text-primary-600 hover:underline text-left font-medium"
          (click)="message.data.action()">
          {{ message.data.label || "Ver más" }}
        </button>
      </div>
    </div>
  </ng-template>
</p-toast>
